<footer class="footer" style="background-color: transparent">
  <div class="container-footer">
    <div class="footer-item">
      <h3 class="footer-title">{{ "footer.about-yes" | translate }}</h3>
      <ul class="list-unstyled">
        <li>
          <a [routerLink]="'/about-us'">{{ "footer.about-us" | translate }}</a>
        </li>
        <li>
          <a [routerLink]="'/terms-of-use'">{{ "footer.terms-of-use" | translate }}</a>
        </li>
        <li>
          <a [routerLink]="'/privacy-policy'">{{ "footer.privacy-policy" | translate }}</a>
        </li>
      </ul>
    </div>
    <div class="footer-item">
      <h3 class="footer-title">{{ "footer.client-service" | translate }}</h3>
      <ul class="list-unstyled">
        <li>
          <a [routerLink]="'/talk-to-us'">{{ "footer.costumer-service" | translate }}</a>
        </li>
        <li>
          <a [routerLink]="'/frequently-asked-questions'">{{ "footer.frequently-asked-questions" | translate }}</a>
        </li>
        <li>
          <a [routerLink]="'/half-price'">{{ "footer.half-price" | translate }}</a>
        </li>
      </ul>
    </div>
    <div class="footer-item">
      <h3 class="footer-title">{{ "footer.social" | translate }}</h3>
      <div class="container-social">
        <a
          (keypress)="('https://www.facebook.com/yes7tickets/')"
          (keydown)="('https://www.facebook.com/yes7tickets/')"
          (keyup)="('https://www.facebook.com/yes7tickets/')"
          tabindex="0"
          href="https://www.facebook.com/yes7tickets"
          rel="noopener"
          target="_blank">
          <img class="nav-item--facebook" src="./../../../assets/icons/facebook-logo-thin.svg" alt="Icone Facebook" />
        </a>
        <a
          (keypress)="('https://www.instagram.com/yes7tickets/')"
          (keydown)="('https://www.instagram.com/yes7tickets/')"
          (keyup)="('https://www.instagram.com/yes7tickets/')"
          tabindex="0"
          href="https://www.instagram.com/yes7tickets/"
          target="_blank"
          rel="noopener">
          <img class="nav-item--instagram" src="./../../../assets/icons/instagram-logo-thin.svg" alt="Icone Instagram"
        /></a>
        <a
          (keydown)="('whats@yes7tickets')"
          (keyup)="('whats@yes7tickets')"
          (keyup)="('whats@yes7tickets')"
          tabindex="0"
          href="https://wa.me/5545998029969?text=Olá,%20gostaria%20de%20mais%20informações!"
          rel="noopener noreferrer"
          target="_blank"
          ><img class="nav-item--whats" src="./../../../assets/icons/whatsapp-logo-thin.svg" alt="email"
        /></a>
        <a
          (keydown)="('contato@yes7tickets.net')"
          (keyup)="('contato@yes7tickets.net')"
          (keyup)="('contato@yes7tickets.net')"
          tabindex="0"
          href="mailto:contato@yes7tickets.net"
          rel="noopener noreferrer"
          target="_blank"
          ><img class="nav-item--email" src="./../../../assets/icons/envelope-thin.svg" alt="email"
        /></a>
      </div>
    </div>
    <div class="footer-item">
      <h3 class="footer-title">{{ "footer.payment-methods" | translate }}</h3>
      <img src="./../../../assets/images/footer/formas-pagamento.png" alt="forma de pagamentos yes7ticket" />
    </div>
    <div class="footer-item" style="justify-content: center; align-items: center;">
      <img src="./../../../assets/images/footer/yes7-ticket-logo-footer.png" alt="logotipo padrão yes7ticket" />
    </div>
  </div>
  <div class="text-center p-3" style="background-color: transparent">
    © 2025 Copyright
    <a href="https://yes7ticket.com/">Yes7 Ticket - by YES 7 IT</a>
  </div>
</footer>
